import BaseApi from '@/services/api/base.api'

class UploadApi extends BaseApi {
  async updateUploadFile(file: Blob): Promise<IUploadFileUpdate.ResponseItem> {
    const formData = new FormData()
    formData.append('file', file)

    const result: IUploadFileUpdate.Response =
      await this.app.$fetchService.post(
        `${this.artistAggregatorBaseUrl}/api/v1/entry-artist/upload`,
        formData,
      )

    return result.success
  }

  async updateUploadImage(
    type: TypeImageUpload,
    file: Blob,
  ): Promise<IUploadImageUpdate.Response> {
    const formData = new FormData()
    formData.append('attachment', file)

    return this.app.$fetchService.post(
      `${this.imageBaseUrl}/image/upload/${type}`,
      formData,
    )
  }
}

export default UploadApi
